module.exports = __webpack_public_path__ + "img/logo.de701db6.png";